import { Component } from "react";

/**
 * Catches a render error below it and shows `fallback` instead (nothing by
 * default), so one broken piece of tenant config does not unmount the whole
 * app into Next's "Application error" screen.
 *
 * `name` labels the console line; `resetKey` clears the error when it changes
 * (pass router.asPath so navigating away recovers).
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error(`[render-error] ${this.props.name || "unnamed"}`, error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render() {
    if (this.state.error) return this.props.fallback ?? null;
    return this.props.children;
  }
}
